import axios from 'axios'

const seafileApi = window.parent.alphaConfig ? window.parent.alphaConfig.ifileApi : ''

export default {
  queryProjectLinkPerm (obj) {
    return axios.get('api/v1/permissions/checkMatterDocumentShareLink', obj)
  },
  getFileId(repoId, path) {
    return axios.get('/document-engine/api/v1/dir/getParentId', {
      params: {
        repoId: repoId,
        path: path
      }
    })
  },
  // 在线预览
  // NOTE: 若未传 repoId 则使用 window.localStorage 的 repoId
  viewOnline (fileName, repoId) {
    fileName = ('/' + fileName).replace(/\/{2,}/g, '/')
    repoId = repoId || window.parent.localStorage.repoId
    let url = seafileApi + 'api2/repos/' + repoId + '/owa-file/?path=' + encodeURIComponent(fileName) + '&action=view'
    return axios.get(url, {
      headers: {
        'Authorization': 'Token ' + window.parent.localStorage.iFileToken
      }
    })
  }
}
